import type { MuiPage } from '@mui/internal-core-docs/MuiPage';

const treeViewApiPages: MuiPage[] = [
  {
    pathname: '/x/api/tree-view/rich-tree-view',
    title: 'RichTreeView',
  },
  {
    pathname: '/x/api/tree-view/rich-tree-view-pro',
    title: 'RichTreeViewPro',
    plan: 'pro',
  },
  {
    pathname: '/x/api/tree-view/simple-tree-view',
    title: 'SimpleTreeView',
  },
  {
    pathname: '/x/api/tree-view/tree-item',
    title: 'TreeItem',
  },
  {
    pathname: '/x/api/tree-view/tree-item-drag-and-drop-overlay',
    title: 'TreeItemDragAndDropOverlay',
  },
  {
    pathname: '/x/api/tree-view/tree-item-icon',
    title: 'TreeItemIcon',
  },
  {
    pathname: '/x/api/tree-view/tree-item-provider',
    title: 'TreeItemProvider',
  },
];
export default treeViewApiPages;
